// extracted by mini-css-extract-plugin
module.exports = {"images":"GalleryScreen-module__images___2zv2L","image":"GalleryScreen-module__image___3sRN1"};